export const integral = ()=>import('@/page/integral/integral.vue')
export const integrallist = () =>import('@/page/integral/integralList.vue')


// WEBPACK FOOTER //
// ./src/router/integral.js